import { Grid } from '@sparky';
import { styled } from '@sparky/stitches';

export const NavigationViewGrid = styled(Grid, {
  position: 'relative',
});

export const NavigationViewFirstItem = styled(Grid.Item, {
  '@mdMax': {
    inset: 0,
    position: 'absolute',
  },
});
export const NavigationViewSecondItem = styled(Grid.Item, {
  '@mdMax': {
    paddingTop: '$16',
  },
});

NavigationViewGrid.displayName = 'NavigationViewGrid';
NavigationViewFirstItem.displayName = 'NavigationViewFirstItem';
NavigationViewSecondItem.displayName = 'NavigationViewSecondItem';
